import { Box, CircularProgress } from '@mui/material';
import { Async } from '../../helpers/types';

export type AsyncRendererProps<T, E> = {
  data: Async<T, E>;
  loadRender?: JSX.Element;
  renderer?: (value: T) => JSX.Element;
};

const defaultLoader = (
  <Box
    className="flex justify-center items-center"
    sx={{ height: '20vh', minWidth: '200px' }}
  >
    <CircularProgress data-testid="defaultLoader" color="info" />
  </Box>
);

export const AsyncRenderer = <TItem, E>({
  renderer,
  loadRender,
  data,
}: AsyncRendererProps<TItem, E>) => {
  switch (data.type) {
    case 'fetch-error':
      return (
        <p>
          Error{data.value ? ': ' : ''}
          <b>
            {typeof data.value === 'string'
              ? data.value
              : JSON.stringify(data.value, null, 2)}
          </b>
        </p>
      );
    case 'not-fetched':
      return <></>;
    case 'fetching':
      return <>{loadRender || defaultLoader}</>;

    case 'fetched':
      return <>{renderer ? renderer(data.value) : null}</>;
  }
};
